module.exports = __webpack_public_path__ + "03_glasses_blue.2e07012b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/03_glasses_blue.png
// module id = wV45
// module chunks = 0